/* eslint-disable no-restricted-syntax -- this line was auto generated, hence fix the issue timely */
import React, { FC } from "react";

import { Button, Icon, Tooltip } from "@bookingcom/bui-react";
import { InfoSignIcon } from "@bookingcom/bui-assets-react/streamline/index.js";
import styles from "./FlightCardGeniusHighlightTooltipWrapper.module.css";
import flights_merch_toolkit_offer_pinning_guardrail_v1 from "../../../../../utils/experiments/genius/flights_merch_toolkit_offer_pinning_guardrail_v1";
import type { HighlightInfoTooltip } from "./types";

type Props = {
  infoTooltip: HighlightInfoTooltip;
};

const FlightCardGeniusHighlightTooltipWrapper: FC<Props> = ({ infoTooltip }) => {
  return (
    <Tooltip
      text={infoTooltip.content}
      onOpen={async () => {
        flights_merch_toolkit_offer_pinning_guardrail_v1.goals.featured_info_displayed();
      }}
    >
      {(triggerAttributes) => (
        <Button
          variant="tertiary"
          className={styles.geniusHighlightTooltipButton}
          attributes={{
            ...triggerAttributes
          }}
        >
          <Icon size="medium" svg={InfoSignIcon} />
        </Button>
      )}
    </Tooltip>
  );
};

export default FlightCardGeniusHighlightTooltipWrapper;
